<template>
  <div class="plateform">
    <Detail :showUser="showUser" :breadcrumbs="breadcrumbs" v-if="model"></Detail>
    <template v-else>
      <commonTable v-if="!checkNode || (checkNode && checkNode.data.depart_id === 0)" tableHead="team" :apiUrl="{url:'team',methods:'addressBookUserIndex'}" ref="commonTable" :params="ruleForm" :selection="false" :tipShow="false" :verifyRemark="false" :cell-class-name="setRowStyle" :config="config">
        <template #table_head>
          <div class="plateform-head common-table-platefrom">
            <div class="psonal">
              <p><span class="title">全部成员</span><span class="count">({{total}})</span></p>
              <div class="search-box-t">
                <el-input prefix-icon="icon iconfont iconicon_search1" v-model="ruleForm.keyword" size="mini" placeholder="搜索员工名称/工号/手机号/邮箱" clearable @input="debounceMixin(doSearch,300)"></el-input>
              </div>
            </div>
          </div>
        </template>
        <template slot="realname" slot-scope="dataset">
          <p class="tags-tip" @click="findTask(dataset.data)">
            <Myavatar :userName="dataset.data.realname" width="28px" height="28px" :imgUrl="dataset.data.user_avatar">{{dataset.data.realname}}</Myavatar>
            <tableTag v-if="getIsDepartAdmin(dataset.data)" :type="8" />
            <tableTag v-if="dataset.data.uid === userInfo.uid" :type="1" />
          </p>
        </template>
      </commonTable>
      <List v-else :selectItem="checkNode.data" :breadcrumbs="breadcrumbs" :getIsDepartAdmin="getIsDepartAdmin" :findTask="findTask"></List>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import tableTag from '@/components/tableTag'
import List from './list'
import Detail from './detail'
import bus from '@/bus'
export default {
  props: {
    checkNode: {
      type: Object,
      default: () => {
        return {
          data: {}
        }
      }
    }
  },
  components: {
    tableTag,
    List,
    Detail
  },
  data() {
    let _this = this
    return {
      ruleForm: {
        keyword: '',
        depart_id: '',
      },
      dataset: [],
      taskData: {},
      otherTask: false,
      config: {
        setCellStyle: _this.setCellStyle,
        check: true
      },
      breadcrumbs: [],
      total: 0,
      model: '',
      showUser: {}
    }
  },
  mounted() {
    // this.init()
    // this.getBreadcrumbs()
    bus.$on('selectDepart', item => {
      this.getBreadcrumbs()
      this.init()
      this.ruleForm.keyword = ''
      this.model = ''
    })
  },
  watch: {
    checkNode: {
      handler() {
        if(!this.checkNode) return
        this.getBreadcrumbs()
        this.init()
        this.ruleForm.keyword = ''
        this.model = ''
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState('layout/layout', {
      tableHeight: state => state.tableHeight,
      userInfo: state => state.userInfo
    }),
    getIsDepartAdmin() { // 是否是负责人
      return (data) => {
        return Boolean(this.checkNode && this.checkNode.data.department_administrators && this.checkNode.data.department_administrators.find(res => res.user.uid === data.uid))
      }
    }
  },
  methods: {
    ...mapMutations('team/team', ['SET_TASKMEANDATA']),
    doSearch() {
      this.init()
    },
    getBreadcrumbs() {
      let node = this.checkNode
      this.breadcrumbs = []
      while (node && node.level > 0) {
        this.breadcrumbs.unshift(node)
        node = node.parent
      }
      console.log(node, this.breadcrumbs)
    },
    async init() {
      // if (this.checkNode && this.checkNode.data.depart_id > 0) return
      console.log('---------123-------')
      await this.$nextTick(() => {})
      if (!this.$refs.commonTable) return
      await this.$refs.commonTable.initQuery()
      this.total = this.$refs.commonTable.ruleForm.pagData.total
    },
    setRowStyle({ row, rowIndex }) {
      return 'color-type-check'
    },
    setCellStyle(data) { // 能否点击进入
      return this.userInfo.uid === data.uid || data.manage_employee_permission
    },
    findTask(data) {
      console.log(data)
      if (this.userInfo.uid === data.uid) {
        this.$router.push('/mine')
      } else if (data.manage_employee_permission) {
        this.showUser = data
        this.model = 'Detail'
        this.breadcrumbs.push({ data: { name: data.realname } })
      }
    }
  }
}
</script>

<style lang="scss" src="./style.scss">
</style>
